import moment from "moment";
export default {
  methods: {
    getWeekDayName(date) {
      return moment(date).format("ddd");
    }
  }
};
